import { ref } from 'vue'

const currentTheme = ref<'dark' | 'light' | undefined>(undefined)

export default function useThemes() {
  return {
    init,
    setTheme,
    currentTheme,
  }
}

const themeKey = 'easy-budget-theme'

const changeTheme = (newTheme) => {
  const element = document.querySelector('html')
  if (newTheme === 'dark') {
    element?.classList.add('app-dark')
  } else {
    element?.classList.remove('app-dark')
  }
}

function setTheme(theme: 'dark' | 'light') {
  localStorage.setItem(themeKey, theme)
  currentTheme.value = theme
  changeTheme(theme)
}

function init() {
  let theme = localStorage.getItem(themeKey) as 'dark' | 'light' | null

  if (theme == null) {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches

    theme = isDarkMode ? 'dark' : 'light'
  }

  setTheme(theme)
}
